export enum LocationTypeEnum {
    FIELD = 415,
    BLOCK = 416,
    COUNTRY = 405,
    PROVINCE = 406,
    BREEDING_LOCATION = 410,
    SEED_STORAGE_LOCATION = 1500
}
